module.exports = __webpack_public_path__ + "static/img/7.420acf5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/2/sp/7.png
// module id = AaKX
// module chunks = 0